import { render } from "./MainHeader.vue?vue&type=template&id=4f11bcd6&ts=true"
import script from "./MainHeader.vue?vue&type=script&lang=ts"
export * from "./MainHeader.vue?vue&type=script&lang=ts"

import "./MainHeader.vue?vue&type=style&index=0&id=4f11bcd6&lang=scss"

import exportComponent from "/Users/matustrebaticky/projects/symbiosy/insights/insights-fe/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/MainHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4f11bcd6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4f11bcd6', __exports__)) {
    api.reload('4f11bcd6', __exports__)
  }
  
  module.hot.accept("./MainHeader.vue?vue&type=template&id=4f11bcd6&ts=true", () => {
    api.rerender('4f11bcd6', render)
  })

}


export default __exports__